var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 53,
    viewBox: "0 0 340 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52513 24.0251C0.158291 25.392 0.158291 27.608 1.52513 28.9749L23.799 51.2487C25.1658 52.6156 27.3819 52.6156 28.7487 51.2487C30.1156 49.8819 30.1156 47.6658 28.7487 46.299L8.94975 26.5L28.7487 6.70101C30.1156 5.33418 30.1156 3.1181 28.7487 1.75126C27.3819 0.384428 25.1658 0.384428 23.799 1.75126L1.52513 24.0251ZM4 30H340V23H4V30Z",
    fill: "#214424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/long-arrow.cc28d43a1f19f25e6b27a84cb38be4ef.svg";
export { ForwardRef as ReactComponent };